























import { Component, Vue } from 'vue-property-decorator'
import { loadSocialMedias, SocialMediaUrl } from '@/helpers/loadSocialMedias'
import AccountIdInput from '@/components/ui/AccountIdInput.vue'
import TechTaskCard from '@/components/ui/TechTaskCard.vue'


// There was an issue importing:  '@/types/social-media'
export enum SocialMediaSource {
    GOOGLE = 'google',
    FACEBOOK = 'facebook',
    BBB = 'bbb',
    YELLOWPAGES = 'yp',
    ANGIESLIST = 'angieslist',
    HOMESTAR = 'homestar',
    HOUZZ = 'houzz',
    HOMEADVISOR = 'homeadvisor',
    PORCH = 'porch',
    NEXTDOOR = 'nextdoor',
    CUSTOM = 'custom'
}


const socialMediaTitles: { [key in SocialMediaSource]: string } = {
    [SocialMediaSource.GOOGLE]: 'Google',
    [SocialMediaSource.FACEBOOK]: 'Facebook',
    [SocialMediaSource.BBB]: 'Better Business Bureau',
    [SocialMediaSource.YELLOWPAGES]: 'Yellow Pages',
    [SocialMediaSource.ANGIESLIST]: 'Angie\'s List',
    [SocialMediaSource.HOMESTAR]: 'HomeStars',
    [SocialMediaSource.HOUZZ]: 'Houzz',
    [SocialMediaSource.HOMEADVISOR]: 'HomeAdvisor',
    [SocialMediaSource.PORCH]: 'Porch',
    [SocialMediaSource.NEXTDOOR]: 'Nextdoor',
    [SocialMediaSource.CUSTOM]: 'Custom'
}


interface RequestPayload {
    pulsemAccountId: number|null;
    department: string|null;
    source: string|null;
    url: string|null;
    title: string|null;
    after: number|null;
    useAccount: boolean;
}


interface SelectItem {
    text: string;
    value: string;
}


@Component({
    components: {
        AccountIdInput,
        TechTaskCard
    }
})
export default class UpdateDepartmentSocialMedia extends Vue {
    locationValid = false
    pulsemAccountId: number|null = null
    department: string|null = null
    source: SocialMediaSource|null = null
    url: string|null = null
    title: string|null = null
    after: number|null = null
    useAccount = false
    accountSocialMediaUrls: SocialMediaUrl[] = []

    get requestPayload(): RequestPayload {
        return {
            pulsemAccountId: this.pulsemAccountId,
            department: this.department,
            source: this.source,
            url: this.url,
            title: this.title,
            after: this.after,
            useAccount: this.useAccount
        }
    }

    /**
     * Is source == 'custom'
     */
    get isCustom(): boolean {
        return this.source === SocialMediaSource.CUSTOM
    }

    get allSocialMediasSelect(): Array<SelectItem> {
        const selectItems: Array<SelectItem> = []
        for (const key in SocialMediaSource) {
            if (Object.prototype.hasOwnProperty.call(SocialMediaSource, key)) {
                const source: SocialMediaSource = SocialMediaSource[key as keyof typeof SocialMediaSource]
                selectItems.push({
                    text: socialMediaTitles[source],
                    value: source
                })
            }
        }
        return selectItems
    }

    /**
     * Account social media urls in format for select picker.
     */
    get accountSocialMediaSelect(): Array<SelectItem> {
        const selectItems: Array<SelectItem> = []
        for (const url of this.accountSocialMediaUrls) {
            selectItems.push({
                text: socialMediaTitles[url.source as SocialMediaSource],
                value: url.source
            })
        }
        return selectItems
    }

    async onLocationChange(locationValid: boolean) {
        this.locationValid = locationValid
        if (this.locationValid) {
            this.accountSocialMediaUrls = (await loadSocialMedias(this.pulsemAccountId as number)).data.socialMediaUrls
        } else {
            this.department = null
            this.source = null
            this.url = null
            this.title = null
            this.after = null
            this.useAccount = false
            this.accountSocialMediaUrls = []
        }
    }

    onSuccess(status: boolean) {
        if (status) {
            this.pulsemAccountId = null
            this.department = null
            this.source = null
            this.url = null
            this.title = null
            this.after = null
            this.useAccount = false
            this.accountSocialMediaUrls = []
        }
    }
}
